<div class="doorbuster-banner" [class.mobile]="topService.isMobile">
  <h1 class="doorbuster-banner__title">Today’s Deals</h1>
  <p class="doorbuster-banner__txt">Today's Deals are launched once a day and expire within 24 hours. Deals are hand-selected from our trusted network of sellers and vetted by our team of experts. Check back daily.</p>
  <a class="doorbuster-banner__link" [routerLink]="userService.getUrlByRole() + '/' + environment.currentDeal.url">GO</a>
</div>
